import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ComparisonService } from '@comparison/feature';
import { ModalTooltipService } from '@sdvor/shared/ui/v2';
import { filter } from 'rxjs';
import { ComparisonTooltipComponent } from './comparison-tooltip.component';

@Injectable({ providedIn: 'root' })
export class ComparisonTooltipComponentService {
  constructor(
    private readonly comparisonService: ComparisonService,
    private readonly destroyRef: DestroyRef,
    private readonly modalTooltipService: ModalTooltipService,
  ) {}

  init(): void {
    this.comparisonService
      .getProductAdded()
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe((code) => {
        const modalRef = this.modalTooltipService.open(ComparisonTooltipComponent, {
          route: 'comparison',
          lifeDuration: 3000,
        });
        modalRef.contentRef.setInput('productCode', code);
      });
  }
}
